/**
 * VerifyEmailRoute — router-level dispatcher for `/verify-email`.
 *
 * The verification email link is fixed at
 * `${FE_URL}/verify-email?token=…` (see
 * `apps/api/src/modules/identity/infrastructure/email/
 * smtp-email.renderer.ts`). This dispatcher reads the `?token=`
 * query param and hands it to the consume page, which validates
 * the format and auto-POSTs on mount.
 */

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { VerifyEmailConsumePage } from './VerifyEmailConsumePage.js';

export function VerifyEmailRoute(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  return <VerifyEmailConsumePage token={token} />;
}
